import { render, staticRenderFns } from "./distributionActivityList.vue?vue&type=template&id=2a1f8022&scoped=true&"
import script from "./distributionActivityList.vue?vue&type=script&lang=js&"
export * from "./distributionActivityList.vue?vue&type=script&lang=js&"
import style0 from "./distributionActivityList.vue?vue&type=style&index=0&id=2a1f8022&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1f8022",
  null
  
)

export default component.exports